<ng-template #suspendedStatsTemplate>
  <li *ngIf="company.billing?.suspendedAt">
    <span class="label">{{ 'table.suspended_since' | translate }}</span>
    <span>{{ company.billing?.suspendedAt | date: 'dd.MM.yyyy' }}</span>
  </li>
</ng-template>

<ng-template #trialStatsTemplate>
  <li *ngIf="(company.billing?.status === BILLING_STATUS.FREE_TRIAL || company.billing?.status === BILLING_STATUS.EARLY_ACCESS) && getTrialStartDate() as startDate">
    <span class="label">{{ 'table.start_date' | translate }}</span>
    <span>{{ startDate | date: 'dd.MM.yyyy' }}</span>
  </li>
  <li>
    <ng-container *ngIf="company.billing?.status === BILLING_STATUS.FREE_TRIAL">
      <span class="label">{{ 'table.monthly_price' | translate }}</span>
      <span>{{ 'subscription.plan.FREE_TRIAL.price' | translate }}</span>
    </ng-container>
    <ng-container *ngIf="company.billing?.status === BILLING_STATUS.EARLY_ACCESS">
      <span class="label">{{ 'table.monthly_price' | translate }}</span>
      <span>{{ 'subscription.plan.EARLY_ACCESS.price' | translate }}</span>
    </ng-container>
    <ng-container *ngIf="company.billing?.status === BILLING_STATUS.FREE">
      <span class="label">{{ 'table.monthly_price' | translate }}</span>
      <span>{{ 'subscription.plan.FREE.price' | translate }}</span>
    </ng-container>
    <ng-container *ngIf="company.billing?.status === BILLING_STATUS.PAST_DUE">
      <span class="label">{{ 'table.monthly_price' | translate }}</span>
      <span>0 {{ 'subscription.plan.currency.UAH' | translate }} ({{ 'subscription.grace' | translate }})</span>
    </ng-container>
  </li>
  <li *ngIf="company.billing?.trialEndAt || company.billing?.nextPaymentDueAt">
    <ng-container *ngIf="company.billing?.status === BILLING_STATUS.FREE_TRIAL">
      <span class="label">{{ 'table.trial_end_date' | translate }}</span>
      <span>{{ company.billing!.trialEndAt | date: 'dd.MM.yyyy' }}</span>
    </ng-container>
    <ng-container *ngIf="company.billing?.status === BILLING_STATUS.EARLY_ACCESS">
      <span class="label">{{ 'table.early_access_end_date' | translate }}</span>
      <span>{{ company.billing!.trialEndAt | date: 'dd.MM.yyyy' }}</span>
    </ng-container>
    <ng-container *ngIf="company.billing?.status === BILLING_STATUS.PAST_DUE">
      <span class="label">{{ 'table.grace_end_date' | translate }}</span>
      <span>{{ getGracePeriodEnd() | date: 'dd.MM.yyyy' }}</span>
    </ng-container>
  </li>
</ng-template>

<ng-template #subscriptionStatsTemplate>
  <li *ngIf="currentSubscription?.startDate as startDate">
    <span class="label">{{ 'table.start_date' | translate }}</span>
    <span>{{ startDate | date: 'dd.MM.yyyy' }}</span>
  </li>
  <li>
    <ng-container *ngIf="!company.billing?.discountPercentage else discountedPriceTemplate">
      <span class="label">{{ 'table.monthly_price' | translate }}</span>
      <span>{{ currentSubscription!.plan.amount }} {{ 'subscription.plan.currency.' + currentSubscription!.plan.currency | translate | uppercase }}</span>
    </ng-container>
    <ng-template #discountedPriceTemplate>
      <span class="label">{{ 'table.monthly_price' | translate }}</span>
      <span class="price">
        <s class="price__old">{{ currentSubscription!.plan.amount }}</s>
        <span class="price__discounted">{{ getPriceWithDiscount(currentSubscription!.plan.amount) | number: '1.0-2' }} {{ 'subscription.plan.currency.' + currentSubscription!.plan.currency | translate | uppercase }}</span>
        <span>
          <app-status-label
            [label]="{
              name: '-' + company.billing!.discountPercentage + '%',
              color: companyService.getLabelColorDataById('BLUE')!
            }" />
        </span>
      </span>
    </ng-template>
  </li>
  <li *ngIf="company.billing as billing">
    <ng-container *ngIf="billing.status === BILLING_STATUS.PAST_DUE else renewalDateTemplate">
      <span class="label">{{ 'table.grace_end_date' | translate }}</span>
      <span>{{ getGracePeriodEnd() | date: 'dd.MM.yyyy' }}</span>
    </ng-container>
    <ng-template #renewalDateTemplate>
      <span class="label">{{ 'table.renewal_date' | translate }}</span>
      <span>{{ billing.nextPaymentDueAt | date: 'dd.MM.yyyy' }}</span>
    </ng-template>
  </li>
</ng-template>

<ul class="subscription-stats">
  <ng-container [ngTemplateOutlet]="
    company.billing?.status === BILLING_STATUS.SUSPENDED || company.billing?.status === BILLING_STATUS.UNSUBSCRIBED
      ? suspendedStatsTemplate
        : !!currentSubscription && company.billing?.status !== BILLING_STATUS.FREE_TRIAL && company.billing?.status !== BILLING_STATUS.EARLY_ACCESS && company.billing?.status !== BILLING_STATUS.FREE
          ? subscriptionStatsTemplate
            : trialStatsTemplate"/>
</ul>
